import type { AcquirerEntity } from "src/app/features/Acquirer/types/AcquirerEntity";
import type { ManualDasConfigurationDto } from "src/app/features/ManualDasConfiguration/types/ManualDasConfigurationDto";
import type { ManualDasConfigurationEntity } from "../../types/ManualDasConfigurationEntity";

export const ManualDasConfigurationDtoToEntity = ({ ...rest }: Readonly<ManualDasConfigurationDto>): ManualDasConfigurationEntity[] => {
    const siteAcq = rest.siteAcquirers ?? {};
    const disabledAcqMap = rest.disabledAcquirers ?? {};

    return (rest.sites ?? [])
        .filter((s) => s != null)
        .map((site) => {
            const id = site.id;
            if (id == null) return undefined;

            // @ts-ignore
            const activeAcq = (siteAcq[id] ?? []).map((a: AcquirerEntity) => ({
                name: a.name,
                acquirerId: a.acquirerId,
                id: a.id,
            }));
            // @ts-ignore
            const disabledAcq = (disabledAcqMap[id] ?? []).map((a: AcquirerEntity) => ({
                name: a.name,
                acquirerId: a.acquirerId,
                id: a.id,
            }));

            if (activeAcq.length === 0 && disabledAcq.length === 0) return undefined;

            return {
                id,
                name: site.name,
                siteId: site.siteId,
                parentUnit: site.parentUnit,
                status: site.status,
                activeDasAcquirers: activeAcq,
                disabledAcquirers: disabledAcq,
            };
        })
        .filter((e) => e !== undefined);
};
